import React, { useState } from "react"

import { ArrowLeft, ArrowRight } from "../Arrow";
import ContentfulLongText from "../ContentfulLongText";

import "./index.css"

const SlideWithTwoMedia = ({ content }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % content.seoContentSlider?.length);
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + content.seoContentSlider?.length) % content.seoContentSlider?.length);
    };

    return (
        <div className="partial-slide-media">
            <div className="slider-content">
                {content.seoContentSlider?.map((item, index) => {
                    const videoId = item.mediaLink ? item.mediaLink.match(/(?:\/|%2F)([A-Za-z0-9_-]{11})/)[1] : '';
                    const youtubeEmbedLink = `https://www.youtube.com/embed/${videoId}`;
                    return (
                        <div key={index} className={`relative inner-content ${index === currentIndex ? 'active' : 'inactive'}`} style={{ display: index === currentIndex ? 'block' : 'none' }}>
                            <div className="grid col-5-5 col-1-md">
                                <div className="relative text-white content">
                                    <button onClick={prevSlide} className="slider-button prev"><ArrowLeft/></button>
                                    <h3 className="mb-5 text-center">{item.title}</h3>
                                    <ContentfulLongText longTextContent={item.content.content} />
                                    <button onClick={nextSlide} className="slider-button next"><ArrowRight/></button>
                                </div>
                                <div className="relative img">
                                    {item.mediaLink ? (
                                        <iframe 
                                        width="424" 
                                        height="238" 
                                        src={youtubeEmbedLink} 
                                        title="We Are Savor Brands" 
                                        frameBorder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                                        allowFullScreen
                                        className='absolute top-0 left-0 right-0 bottom-0 w-full h-full fit-cover'
                                        ></iframe>
                                    ):(
                                        <img className='absolute top-0 left-0 right-0 bottom-0 w-full h-full fit-cover' src={item.media?.gatsbyImageData?.images?.fallback?.src || 'https://images.ctfassets.net/vhts96p7twn6/246wTv068JR4pc4o3r8sgL/6dc29b5a44c51b3276a9694589167ef0/PonoLuxHero2.jpg'} alt="Blog Page" />
                                    )}
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default SlideWithTwoMedia